import { useEventCallback } from '@mui/material';
import { useCallback, useState } from 'react';

interface Props {
  fn: () => void;
  delay: number;
}

export function useInterval({ fn, delay }: Props) {
  const [intervalId, setIntervalId] = useState<ReturnType<
    typeof setInterval
  > | null>(null);

  const killInterval = useCallback(() => {
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
  }, [intervalId]);

  const initiateInterval = useEventCallback(() => {
    if (!intervalId) {
      const newIntervalId = setInterval(fn, delay);
      setIntervalId(newIntervalId);
    }
  });

  return { intervalId, killInterval, initiateInterval };
}
